@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

$var-actions-top-offset: -16px;
$var-tabs-navigation-top-offset: 48px;

.job-form {

	&__submit-section {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: Constants.$val-spacing-xs;
		background-color: Colors.$col-white;
		padding: Constants.$val-spacing-m Constants.$val-spacing-l;
		z-index: 4;
		border-bottom: 2px solid Colors.$col-greyBackground;
		top: $var-actions-top-offset;
		position: sticky;

		&__hint {
			color: Colors.$col-greyFontLight;
			font-style: italic;
			flex: 1;
			margin-bottom: Constants.$val-spacing-l;
		}
	}

	&__tabs-navigation {
		position: sticky;
		top: $var-tabs-navigation-top-offset;
		z-index: 4;
	}

	&__tab {
		display: flex;
		gap: Constants.$val-spacing-xs;
		align-items: center;

		& > [class^="icon-warning"] {
			color: Colors.$col-canceledRed;
			font-size: Constants.$val-fontSizeBig;

		}
	}
}

.billing-code-change-modal {
	display: flex;
	flex-direction: column;
	gap: Constants.$val-spacing-m;
	max-height: 60vh;
	overflow-y: auto;
	padding-right: Constants.$val-spacing-xs;

	&__intro {
		color: Colors.$col-design-gray8;
		font-size: Constants.$val-fontSizeBig;
		line-height: Constants.$val-lineHeightBig;
	}

	&__content {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
	}

	&__section {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-xs;
	}

	&__section-title {
		color: Colors.$col-design-gray9;
		font-size: Constants.$val-fontSizeRegular;
		font-weight: 600;
		line-height: Constants.$val-lineHeightRegular;
	}

	&__section-list {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-xxs;
	}

	&__row {
		color: Colors.$col-design-gray8;
		font-size: Constants.$val-fontSizeRegular;
		line-height: Constants.$val-lineHeightRegular;
	}

	&__billing-code {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	&__separator {
		color: Colors.$col-design-gray8;
		padding: 0 Constants.$val-spacing-xs;
	}

	&__group {
		display: inline-flex;
		align-items: center;
		gap: Constants.$val-spacing-xs;
	}
}